// 末尾にある書きかけのリンクや画像の書式。[ から始まり、] がまだないもの、] で終わるもの、](URL の途中で ) がまだないものに合う。
// [文字](URL) と閉じたリンクや、] の後に ( 以外が続いた角括弧の文には合わない。playground の streamingMarkdown.ts から移した
// eslint-disable-next-line security/detect-unsafe-regex -- 量指定子を入れ子にしておらず、各部分の文字の集合が重ならないので、後戻りは文の長さに比例する程度にとどまる
const INCOMPLETE_LINK_AT_END = /!?\[[^\[\]\n]*(?:\](?:\([^\(\)\s]*)?)?$/v

/**
 * 書いている途中の回答の末尾にある、書きかけのリンクを表示から外す。
 * 回答は数文字ずつ届くので、そのまま Markdown にすると、リンクになる前の [文字](https://... が一度見えてから、閉じた時点でリンクに変わる。
 * 書きかけの部分を外し、閉じてからリンクとしてまとめて出す。] の後に ( 以外が続けば、リンクではないので、その時点で文のまま出す
 */
export const hideIncompleteMarkdownLink = (text: string): string => text.replace(INCOMPLETE_LINK_AT_END, '')
